<template>
  <div class="editor-module-container">
    <div class="editor-module-title">
      <div
        class="left-content"
        @click="clickRenameModule('', customModuleTitle)"
      >
        <img v-if="moduleIcon" class="module-icon" :src="moduleIcon" alt="" />
        <div class="module-title">{{ customModuleTitle }}</div>
        <i class="iconfont iconedit-"></i>
        <div v-if="issueCount" class="module-issue-count">
          {{ issueCount }} 项待修复
        </div>
      </div>
      <div class="right-content">
        <i v-if="honor.length > 1" class="iconfont iconpaixu">
          <ExperienceSequence
            :list="honor"
            displayKey="name"
            @draggableChange="sequenceChange"
          />
        </i>
        <i
          class="iconfont iconshanchujianli"
          @click="handleClickRemoveModule"
        ></i>
      </div>
    </div>
    <div class="editor-form-list">
      <transition-group :name="displayAnimation ? 'list' : ''">
        <div
          v-for="item in honor"
          :key="item.id"
          :id="`experience${item.id}`"
          class="editor-form-content"
          @click="editItem(item, 'sameInfo')"
        >
          <div class="form-item-header">
            <div class="form-item-title">
              <div class="form-item-name">{{ item.name }}</div>
              <div class="form-item-edit-content">
                <i
                  class="iconfont iconshanchujianli"
                  @click.stop="removeExperience(item)"
                ></i>
                <i
                  class="iconfont iconchevron-down"
                  :class="{ active: editId === item.id }"
                  @click.stop="editItem(item, 'sameInfo')"
                ></i>
              </div>
            </div>
            <div
              v-if="item.name || item.present"
              class="form-item-content"
            >
              <div class="content-text">{{ item.name }}</div>
              <div class="content-text">{{ item.present }}</div>
            </div>
          </div>
          <el-collapse-transition>
            <div
              v-show="editId === item.id"
              class="editor-module-content editor-base-form"
              @click.stop
            >
              <EditorInput
                v-model="item.name"
                placeholder="请输入"
                title="荣誉奖项名称"
                style="width: 100%"
              />
              <EditorInput
                v-model="item.present"
                placeholder="请输入"
                label="获奖时间"
                style="width: 100%"
              />
              <div class="complete-button-wrapper">
                <CompleteButton
                  text="保存"
                  @clickBtn="saveCustomExperience(item.id, 'click')"
                />
              </div>
            </div>
          </el-collapse-transition>
        </div>
      </transition-group>
      <div
        v-if="displayAddBtn"
        class="editor-module-add"
        @click="clickAddExperience"
      >
        <i class="iconfont iconplus-circle"></i>
        <span>添加一段{{ customModuleTitle }}</span>
      </div>
    </div>
    <RenameModuleModal
      ref="renameModalRef"
      @confirm="confirmModuleRename($event, moduleId)"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { editorFormMixin } from '../../mixins/editor-form';
import RenameModuleModal from '../RenameModuleModal/RenameModuleModal.vue';
import ExperienceSequence from '../ExperienceSequence/ExperienceSequence.vue';
import EditorInput from '../EditorInput/EditorInput.vue';
import CompleteButton from '../CompleteButton/CompleteButton.vue';

const keys = ['name', 'present'];

export default {
  name: 'EditorHonor',
  mixins: [editorFormMixin],
  components: {
    RenameModuleModal,
    ExperienceSequence,
    EditorInput,
    CompleteButton,
  },
  props: {
    editId: {
      type: [String, Number],
      default: '',
    },
    moduleId: {
      type: Number,
      default: '',
    },
    moduleType: {
      type: String,
      default: '',
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('editor', ['cvDetail', 'honor']),
    displayAddBtn() {
      return this.honor.every((item) => item.id !== `${this.moduleId}-edit`);
    },
  },
  watch: {
    editId(_, oldVal) {
      if (this.clickSaveBtn) return;
      if (oldVal === `${this.moduleId}-edit`) {
        this.checkCustomModuleEmpty('honor', oldVal, keys, this.moduleId);
      } else if (oldVal) {
        this.saveCustomExperience(oldVal);
      }
    },
  },
  methods: {
    saveCustomExperience(id, operation) {
      const payload = this.honor.find((item) => item.id === id);
      if (!payload) return;
      payload.lang = this.cvDetail.basic_info.lang;
      this.updateFormCustomExperience(payload, this.moduleId, 'honor', operation);
    },
    async removeExperience(item) {
      try {
        const confirm = await this.$wondercv.showConfirm({
          title: '温馨提示',
          content: `确定要删除${item.name || ''}吗？`,
          warningText: '经历删除后将无法恢复',
          confirmText: '确认',
          cancelText: '取消',
        });
        if (confirm) {
          this.clickRemoveExperience(item, 'honor');
        }
      } catch (error) {
        console.log(error, 'error');
      }
    },
    editItem(item, sameInfo) {
      this.$emit('editItem', item.id, sameInfo);
    },
    sequenceChange() {
      this.experienceSequenceChange('honor', this.moduleId);
    },
    async handleClickRemoveModule() {
      const confirm = await this.$wondercv.showConfirm({
        title: '温馨提示',
        content: `确定要删除${this.customModuleTitle}吗？`,
        confirmText: '确认',
        cancelText: '取消',
      });
      if (confirm) {
        this.clickRemoveModule(this.moduleId);
      }
    },
    clickAddExperience() {
      this.$store.commit('editor/setModuleData', {
        type: 'honor',
        info: [
          ...(this.$store.state.editor?.honor || []),
          {
            id: `${this.moduleId}-edit`,
            name: '',
            present: '',
          },
        ],
      });
      this.$emit('editItem', `${this.moduleId}-edit`);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
@import '../../styles/editor.scss';
</style>
